module.exports = __webpack_public_path__ + "img/headshot.ca0a2d7b.jpg";